module.exports = __webpack_public_path__ + "static/img/s55.5fbc52ef.png";